import axios from 'axios';

export const supplierTypeApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/suppliers-type`,
    headers: {
        'Content-Type': 'application/json'
    }
})